import React, { Component, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { get, post } from "util/requests";
import styles from "./edc.module.css";
import EDCSidebar from "./components/edc_sidebar";
import Crf from "./components/crf";
import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { MenuOpenIcon } from "ui/icons";
import { shouldRenderDataField, resolveCrfDataFlag } from "ui/crfs/segment/helpers";

export default function EDC() {
  const { subject_id, visit_index, crf_id, site_id, study_id, form_type, multi_entry_crf_id } = useParams();
  const user_domains = useSelector((state) => state.user.userData.domains);

  const [crfList, setCrfList] = useState([]);
  const [globalForms, setGlobalForms] = useState([]);
  const [corelabCrfList, setCorelabCrfList] = useState([]);
  const [showingSidebar, setShowingSidebar] = useState(true);
  const [multientryCrfFlags, setMultientryCrfFlags] = useState(null);
  const location = useLocation();

  const fetchSidebarData = () => {
    //this gets the sidebar crf content and the log form sidebars
    get(`/edc_crfs_for_visit/${study_id}/${visit_index}/${subject_id}`).then((ret) => {
      setCrfList(ret.data.visit_crfs);
      setGlobalForms(ret.data.global_forms);
      if (ret.data.corelab_crfs) {
        setCorelabCrfList(ret.data.corelab_crfs);
      }
    });
  };

  useEffect(() => {
    post("/footprint", {
      path: location.pathname,
      action: "pageload",
      name: "edc_base",
      subject_id,
      study_id,
      site_id,
    });
  }, [location.pathname]);

  useEffect(() => {
    fetchSidebarData();
  }, [visit_index]);

  const updateCrfQueryStatus = (_crf_id, status) => {
    let crf_list = cloneDeep(crfList);

    let crf = crf_list.find((c) => c.id === _crf_id);
    if (crf) {
      crf.query_status = status;
      setCrfList(crf_list);
    }
    //search in global forms
    else if (!crf) {
      crf = globalForms
        .reduce((accum, obj) => {
          obj.entries.forEach((crf) => accum.push(crf));
          return accum;
        }, [])
        .find((c) => c.id === _crf_id);
      if (crf) {
        crf.query_status = status;
        setGlobalForms(globalForms);
      }
    } else if (!crf && form_type === "multi_entry") {
      post("multi_entry_crf", {
        multi_entry_crf_id,
        crf_id,
        subject_id,
        visit_index,
        study_id,
        pathname: location.pathname,
      }).then((ret) => {
        let crf = ret.data;
        crf.query_status = status;
        let formsIndex = globalForms.findIndex((gf) => gf.id === crf_id);
        globalForms[formsIndex].entries.push(crf);
        setGlobalForms(globalForms);
      });
    }
  };

  const updateCrfStatus = (_crf_id, status, form_type, multi_entry_crf_id) => {
    return new Promise((resolve) => {
      let crf_list = cloneDeep(crfList);
      let global_forms_list = cloneDeep(globalForms);

      let crf = crf_list.find((c) => c.id === _crf_id);

      //search in global forms
      if (form_type === "multi_entry") {
        crf = global_forms_list.find((g) => g.id === _crf_id);
        if (crf) {
          //we do not have the appropriate statuses resolved for the multi-entry crfs, so we respond will null to keep the qc status local to the crf page only
          if (
            !global_forms_list
              .reduce((accum, obj) => {
                obj.entries.forEach((crf) => accum.push(crf));
                return accum;
              }, [])
              .find((c) => c.id === multi_entry_crf_id)
          ) {
            crf.total = crf.total += 1;
            let gf = global_forms_list.find((gf) => gf.id === _crf_id);
            gf.entries.push({ id: multi_entry_crf_id });
            setGlobalForms(global_forms_list);
          }

          // resolve("data_complete");
          // return;
        }
      }

      if (status === "data" && crf && crf.status !== "data_complete") {
        crf.status = "data";
        setCrfList(crf_list);
        resolve("data");
      } else if (crf && status === "data_complete") {
        crf.status = "data_complete";
        setCrfList(crf_list);
        resolve("data_complete");
      } else if (crf && status === "remove_data_complete") {
        crf.status = "data";
        setCrfList(crf_list);
        resolve("data");
      } else if (status === "data" && !crf) {
        resolve("data");
      }
    });
  };

  const updateCrfFlags = (_crf_id, _crf_data, form_type, _multi_entry_crf_id) => {
    return new Promise((resolve) => {
      let flags;
      let crf_list = cloneDeep(crfList);

      let global_forms_list = cloneDeep(globalForms);

      let crf = crf_list.find((c) => c.id === _crf_id);
      //search in global forms
      if (form_type === "multi_entry" || !crf) {
        crf = global_forms_list.find((g) => g.id === _crf_id);
        if (crf) {
          //we do not have the appropriate statuses resolved for the multi-entry crfs, so we respond will null to keep the qc status local to the crf page only
          if (
            !global_forms_list
              .reduce((accum, obj) => {
                obj.entries.forEach((crf) => accum.push(crf));
                return accum;
              }, [])
              .find((c) => c.id === _multi_entry_crf_id)
          ) {
            crf.total = crf.total += 1;
            let gf = global_forms_list.find((gf) => gf.id === _crf_id);
            gf.entries.push({ id: _multi_entry_crf_id });
            // setGlobalForms(global_forms_list);
          }
        }
      } else if (form_type === "corelab") {
        crf_list = cloneDeep(corelabCrfList);
        crf = crf_list.find((c) => c.id === _crf_id);
      }
      let tmp_field_array = cloneDeep(_crf_data.design.fields);

      //figure out if we have no, partial, or full data, and then add that "data" flag
      //it's ideal for this function to take the unfiltered field array to be able to check if we have any data on any fields, vs just the required fields
      let data_flag = resolveCrfDataFlag(tmp_field_array, _crf_data);
      //fiter out fields that are not currently being shown
      tmp_field_array = tmp_field_array.filter(
        (field) =>
          shouldRenderDataField(field, tmp_field_array, _crf_data) && !["heading", "add_another"].includes(field.type)
      );

      //filter out fields that are not marked as required
      let required_tmp_field_array = tmp_field_array.filter((field) => field.required);
      if (required_tmp_field_array.length > 0) {
        tmp_field_array = required_tmp_field_array;
      }

      let _flags = tmp_field_array.map((d) => d.value_obj?.flags || []);
      flags = [];
      _flags.forEach((f) => (flags = flags.concat(f)));
      flags = Array.from(new Set(flags));
      flags.forEach((flag) => {
        if (!_flags.map((f) => f.includes(flag)).includes(false)) {
          flags.push(`all_${flag}`);
        }
      });

      if (data_flag) {
        flags.push(data_flag);
      }

      if (crf) {
        if (form_type === "corelab") {
          crf.flags = flags;
          setCorelabCrfList(crf_list);
        } else if (form_type === "multi_entry") {
          crf.flags = global_forms_list
            .reduce((accum, obj) => {
              accum.concat(obj.flags || []);
              return accum;
            }, [])
            .concat(crf.flags)
            .filter((f) => RegExp(/^re/).test(f));
          setGlobalForms(global_forms_list);
        } else {
          crf.flags = flags;
          setCrfList(crf_list);
        }
      }

      let url = `/crf_flags/${subject_id}/${crf_id}`;
      if (form_type === "multi_entry" || _multi_entry_crf_id) {
        // url = `/crf_flags/${subject_id}/${crf_id}/${multi_entry_crf_id}`;
        url = `/crf_flags/${subject_id}/${_multi_entry_crf_id}`;
      }
      post(url, {
        flags,
        study_id,
      });

      //we don't have the crfList resolved if we are multientry forms, so set the flags locally so we can assess data state for the dropmenu
      if (form_type === "multi_entry") {
        setMultientryCrfFlags(flags);
      }

      resolve();
    });
  };

  const hideSidebar = (state) => {
    setShowingSidebar(!state);
  };

  return (
    <div className={styles.wrapper}>
      {showingSidebar ? (
        <EDCSidebar
          visit_index={visit_index}
          crf_id={crf_id}
          subject_id={subject_id}
          crfList={crfList}
          globalFormsList={globalForms}
          hideSidebar={hideSidebar}
          corelabCrfList={corelabCrfList}
        />
      ) : (
        <div>
          <MenuOpenIcon onClick={() => hideSidebar(false)} />
        </div>
      )}
      {form_type === "crf" ? (
        <Crf
          form_type={"crf"}
          key="crf"
          crf_id={crf_id}
          subject_id={subject_id}
          updateCrfQueryStatus={updateCrfQueryStatus}
          updateCrfStatus={updateCrfStatus}
          updateCrfFlags={updateCrfFlags}
          visit_index={visit_index}
          study_id={study_id}
          site_id={site_id}
          fetchSidebarData={fetchSidebarData}
          crfFlags={crfList?.find((c) => c.id === crf_id)?.flags || []}
        />
      ) : null}
      {form_type === "corelab" ? (
        <Crf
          form_type={"corelab"}
          key="corelab"
          crf_id={crf_id}
          subject_id={subject_id}
          updateCrfQueryStatus={updateCrfQueryStatus}
          updateCrfStatus={updateCrfStatus}
          updateCrfFlags={updateCrfFlags}
          visit_index={visit_index}
          study_id={study_id}
          site_id={site_id}
          fetchSidebarData={fetchSidebarData}
          crfFlags={crfList?.find((c) => c.id === crf_id)?.flags || []}
        />
      ) : null}
      {form_type === "multi_entry" ? (
        <Crf
          form_type={"multi_entry"}
          multi_entry_crf_id={multi_entry_crf_id}
          key="multi_entry"
          crf_id={crf_id}
          subject_id={subject_id}
          updateCrfQueryStatus={updateCrfQueryStatus}
          updateCrfStatus={updateCrfStatus}
          updateCrfFlags={updateCrfFlags}
          visit_index={visit_index}
          study_id={study_id}
          site_id={site_id}
          fetchSidebarData={fetchSidebarData}
          crfFlags={multientryCrfFlags}
        />
      ) : null}
    </div>
  );
}
